export default {
    PvPgameTitle: "摘星星-遊戲設定",
    gameTitle: "摘星星",
    topicLabel: "主題",
    correctItems: "正答項目",
    correctItemsPlaceholder: "輸入正確詞彙，可用換行或逗號(,)分隔，按下Enter確認新增項目",
    errorItems: "錯誤項目",
    errorItemsPlaceholder: "輸入錯誤詞彙，可用換行或逗號(,)分隔，按下Enter確認新增項目",
    gameDuration: "遊戲時長",
    second: "秒",
    saveSettings: "儲存設定",
    startGame: "開始遊戲",
    pauseGame: "暫停遊戲",
    resumeGame: "繼續遊戲",
    gameOver: "遊戲結束",
    leftSide: "左方",
    rightSide: "右方",
    leftWins: "左方獲勝！",
    rightWins: "右方獲勝！",
    tie: "平局！",
    playAgain: "再玩一次",
    wordExists: "詞彙已存在，無須重複加入",
    maxVocabulary: "正答項目已達最大值，請刪減項目再加入",
    maxErrorVocabulary: "錯誤項目已達最大值，請刪減項目再加入",
    topic: "主題",
    inputTopic: "請輸入主題",
    backgroundSetting: "背景設定",
    ocean: "海洋",
    desert: "沙漠",
    forest: "森林",
    gameSpeed: "遊戲速度",
    speedSlow: "慢",
    speedMedium: "中",
    speedFast: "快",
    
    // 遊戲結束畫面新增字串
    win: "勝利",
    items: "個",
    wrongItems: "答對題目",
    maxCombo: "最高連擊",
    showAnswers: "A",
    gamePaused: "活動暫停",
    referenceAnswers: "參考答案",
    clearData: "清空設定",
    sendSuccess: "遊戲資料已成功推送！",
    sendCooldown: "已按過送出，請等候1分鐘才可再操作",
    pushSuccess: "遊戲已成功推送到 HiTeach！",
    pushFailed: "推送失敗：{message}",
    tokenRefreshing: "正在刷新授權資訊，請稍後再試...",
    configLoadSuccess: "成功載入遊戲設定",
    configLoadFailed: "載入失敗（將使用範例設定）",
    unsubmittedWarning: "發現到輸入框尚有未按下Enter 的詞彙，請確認後再儲存!",

    // 雙人模式玩家標籤
    leftPlayer: "左側玩家",
    rightPlayer: "右側玩家",
}
